import { render, staticRenderFns } from "./Big_data.vue?vue&type=template&id=52878f6a"
import script from "./Big_data.vue?vue&type=script&lang=js"
export * from "./Big_data.vue?vue&type=script&lang=js"
import style0 from "./Big_data.vue?vue&type=style&index=0&id=52878f6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports